module.exports = __webpack_public_path__ + "static/20141025_110150-63d7918ddc5846eee8accd10a05aa2d0.jpg";